module.exports = __webpack_public_path__ + "media/34_Long.96bf8c0f.mp3";